import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';
import '../stylesheets/components/FlashMessages.css';

import PropTypes from 'prop-types';

const FlashMessage = ({ object, columnWrap = false, className = '' }) => {
  const [showMessage, setShowMessage] = React.useState(false);

  // @see https://stackoverflow.com/a/66359848
  window.history.replaceState({}, document.title);

  React.useEffect(() => {
    if (object.message && object.message !== "") {
      const toRef = setTimeout(() => {
        setShowMessage(true);
        clearTimeout(toRef);
      }, 0);
    }
  }, [object]);

  React.useEffect(() => {
    if (showMessage) {
      const toRef = setTimeout(() => {
        setShowMessage(false);
        object.message = "";
        clearTimeout(toRef);
      }, 10000)
    }
  }, [object, showMessage]);

  const flashMessageContent = function (flashMessage) {
    return (
      <div
        className={`flash-message flash-message--${flashMessage.className}`}
      >
        {flashMessage.message}
      </div>
    );
  };

  return (
    <>
      {showMessage && (
        <>
          {object?.hasOwnProperty('message') && (
            <>
              {!className && columnWrap && (
                <div className="grid-container">
                  <Grid className="grid-padding-x align-justify">
                    <Cell small={12}>{flashMessageContent(object)}</Cell>
                  </Grid>
                </div>
              )}

              {className && columnWrap && <>{flashMessageContent(object)}</>}

              {!columnWrap && flashMessageContent(object)}
            </>
          )}
        </>
      )}
    </>
  );
};

export default FlashMessage;

FlashMessage.propTypes = {
  object: PropTypes.object,
  columnWrap: PropTypes.bool,
  className: PropTypes.string
};